import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Icon from '../Icon/index.esm.js';
import Button from '../Button/index.esm.js';

var IconButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var icon = props.icon,
      iconSize = props.iconSize,
      label = props.label,
      rounded = props.rounded,
      iconRotate = props.iconRotate,
      rest = _objectWithoutPropertiesLoose(props, ["icon", "iconSize", "label", "rounded", "iconRotate"]);

  var styleProps = {};

  if (rounded) {
    // TODO: fix up padding for the rounded option
    styleProps.borderRadius = 'rounded-full';
  }

  return React__default.createElement(Button, _extends({
    ref: ref,
    spacing: "compact",
    "aria-label": label
  }, styleProps, rest), "\u200B", React__default.createElement(Icon, {
    name: icon,
    size: iconSize,
    transform: "transform",
    rotate: iconRotate,
    transitionProperty: "transition-all",
    transitionDuration: "duration-200",
    transitionTimingFunction: "ease-in-out"
  }));
});

if (__DEV__) {
  IconButton.displayName = 'IconButton';
}

export default IconButton;
//# sourceMappingURL=index.esm.js.map
